import { useEffect, useState } from "react";
import { View } from "react-native";

export interface InfiniteProgressProps {
  className?: string;
  frequency?: number;
  size?: number;
  valueClassName?: string;
}

export function InfiniteProgress({ className, frequency = 1, size = 50, valueClassName }: Readonly<InfiniteProgressProps>) {
  const [left, setLeft] = useState<number>(-size);
  const [width, setWidth] = useState<number>(size);

  useEffect(() => {
    const interval = setInterval(
      () =>
        setLeft((value) => {
          const newValue = value + ((width + size) * frequency) / 50;
          return newValue > width ? -size : newValue;
        }),
      20,
    );
    return () => {
      clearInterval(interval);
    };
  }, [frequency, size, width]);

  return (
    <View className={`bg-background-300 h-3 overflow-hidden relative rounded-full ${className}`} onLayout={(e) => setWidth(e.nativeEvent.layout.width)}>
      <View className={`absolute bg-primary-500 h-full rounded-full w-[${size}px] ${valueClassName}`} style={{ left }} />
    </View>
  );
}
